module.exports = __webpack_public_path__ + "img/radio-ksa.e742b899.png";